(() => {
  const box = document.getElementById('twl-replacement');
  if (!box || box.dataset.initialized) return;
  box.dataset.initialized = 'true';
  box.querySelector('input[value="Yes"]').disabled = false;
  const form = box.closest('form');
  const select = document.getElementById('twl-replacement-select');
  const choice = document.getElementById('twl-replacement-choice');
  const status = document.getElementById('twl-replacement-status');
  const labelInput = document.getElementById('twl-replacement-label');
  const idInput = document.getElementById('twl-replacement-id');
  const note = document.getElementById('CartSpecialInstructions');
  const strings = JSON.parse(document.getElementById('twl-replacement-strings').textContent);
  const root = window.Shopify?.routes?.root || '/';
  const checkout = form.querySelector('[name="checkout"]');
  let loaded = false;
  let loading = null;
  let savedChoice = box.dataset.savedId;
  let queue = Promise.resolve();
  let replaying = false;
  const permission = () => box.querySelector('input[type="radio"]:checked')?.value || '';
  const cleanNote = value => value.replace(/\[Plant replacement preference\][\s\S]*?\[\/Plant replacement preference\]/g, '').trim();
  if (note) note.value = cleanNote(note.value);
  const messages = text => { status.textContent = text; };
  const chosenLabel = () => select.value === 'staff' ? strings.staff : select.selectedOptions[0]?.dataset.label || '';
  const updateFields = () => {
    const yes = permission() === 'Yes';
    document.getElementById('twl-replacement-confirmed').value = permission() ? 'Yes' : '';
    choice.hidden = !yes;
    select.required = yes;
    select.disabled = !yes;
    idInput.value = yes ? select.value : '';
    labelInput.value = yes ? chosenLabel() : '';
  };
  async function loadOptions(refresh = false) {
    if (refresh && !loading) {
      savedChoice = select.value;
      select.querySelectorAll('optgroup').forEach(group => group.remove());
      loaded = false;
    }
    if (loaded) return;
    if (loading) return loading;
    loading = (async () => {
      messages(strings.loading);
      const groups = new Map();
      for (const key of ['potted','tissue','wet_leaf']) {
        const group = document.createElement('optgroup');
        group.label = strings[key];
        groups.set(key, group);
      }
      let pages = 1;
      for (let page = 1; page <= pages; page++) {
        const url = new URL(root + 'collections/all', location.origin);
        url.searchParams.set('section_id', 'twl-plant-replacement-options');
        url.searchParams.set('page', String(page));
        const response = await fetch(url, {credentials:'same-origin',cache:'no-store'});
        if (!response.ok) throw new Error('catalog');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const container = doc.querySelector('[data-twl-pages]');
        if (!container) throw new Error('catalog');
        pages = Number(container.dataset.twlPages);
        for (const option of container.querySelectorAll('option')) groups.get(option.dataset.group)?.append(option);
      }
      for (const group of groups.values()) {
        [...group.children].sort((a,b)=>a.textContent.localeCompare(b.textContent)).forEach(option=>group.append(option));
        if (group.children.length) select.append(group);
      }
      loaded = true;
      if (savedChoice) {
        if ([...select.options].some(option=>option.value===savedChoice)) select.value=savedChoice;
        else { select.value=''; messages(strings.unavailable); }
        savedChoice='';
      }
      updateFields();
      if (!status.textContent.includes(strings.unavailable)) messages('');
    })().catch(error => {messages(strings.load_error); throw error;}).finally(()=>{loading=null;});
    return loading;
  }
  function save() {
    if (!permission()) return Promise.resolve();
    updateFields();
    const yes = permission() === 'Yes';
    const label = chosenLabel();
    const userNote = note ? cleanNote(note.value) : '';
    const payload = {attributes:{'Plant replacement choice confirmed':'Yes','Plant substitutions':yes?'Yes':'No','Preferred replacement plant':yes?label:'','Plant replacement variant':yes?select.value:''},note:userNote};
    queue = queue.catch(()=>{}).then(async () => {
      messages(strings.saving);
      const response = await fetch(root+'cart/update.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload)});
      if (!response.ok) throw new Error('save');
      const data=await response.json();
      if (data.attributes['Plant substitutions'] !== payload.attributes['Plant substitutions'] || data.note !== payload.note) throw new Error('verify');
      messages(strings.saved);
    });
    return queue;
  }
  async function savePackingPreference() {
    const eligibility=JSON.parse(document.getElementById('twl-replacement-lines').textContent);
    const yes=permission()==='Yes';
    const fields={_twl_plant_substitutions:yes?'Yes':'No',_twl_preferred_plant:yes?chosenLabel():''};
    const response=await fetch(root+'cart.js',{credentials:'same-origin',cache:'no-store'});
    if(!response.ok) throw new Error('cart');
    let cart=await response.json();
    const initial=cart.items.map(item=>({key:item.key,variant:item.variant_id,quantity:item.quantity,plant:eligibility[item.key]===true}));
    for(let i=0;i<initial.length;i++) {
      const expected=initial[i];
      const item=cart.items[i];
      if(!item || item.variant_id!==expected.variant || item.quantity!==expected.quantity) throw new Error('cart_changed');
      const properties={...(item.properties||{})};
      const desired=expected.plant?{...fields,_twl_preference_line:properties._twl_preference_line||item.key}:{_twl_plant_substitutions:'',_twl_preferred_plant:''};
      if(Object.entries(desired).every(([key,value])=>(properties[key]||'')===value)) continue;
      Object.assign(properties,desired);
      const changed=await fetch(root+'cart/change.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:item.key,quantity:item.quantity,properties})});
      if(!changed.ok) throw new Error('preference');
      cart=await changed.json();
      const saved=cart.items[i];
      if(!saved || saved.variant_id!==expected.variant || saved.quantity!==expected.quantity || Object.entries(desired).some(([key,value])=>(saved.properties?.[key]||'')!==value)) throw new Error('preference_verify');
      cart.items.forEach((entry,index)=>{if(entry.variant_id!==initial[index]?.variant) throw new Error('cart_changed'); eligibility[entry.key]=initial[index].plant;});
      document.getElementById('twl-replacement-lines').textContent=JSON.stringify(eligibility);
    }
  }
  box.addEventListener('change', async event => {
    updateFields();
    try {
      if (permission()==='Yes') await loadOptions();
      if (permission()==='No' || select.value) await save();
    } catch { if (loaded) messages(strings.save_error); }
  });
  note?.addEventListener('change', () => { if (permission()==='No'||select.value) save().catch(()=>messages(strings.save_error)); });
  form.addEventListener('submit', async event => {
    if (replaying) return;
    const submitter=event.submitter;
    if (submitter?.name !== 'checkout') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!permission()) {
      messages(strings.choice_required);
      box.querySelector('input[type="radio"]').focus();
      return;
    }
    if (checkout) checkout.disabled=true;
    try {
      if (permission()==='Yes') {
        await loadOptions(true);
        if (!select.value) {messages(strings.required);select.focus();return;}
      }
      await save();
      await savePackingPreference();
      if (note) note.value=cleanNote(note.value);
      replaying=true;
      if (checkout) checkout.disabled=false;
      form.requestSubmit(submitter);
    } catch {messages(loaded || permission()==='No' ? strings.save_error : strings.load_error);}
    finally {if(checkout) checkout.disabled=false;}
  },true);
  updateFields();
  if(permission()==='Yes') loadOptions().catch(()=>{});
})();

